import { keyframes } from "styled-components";

export const slideUp = keyframes`
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
`;

export const designElementsTransformScale = keyframes`
    from {
        transform: scale(1);
    }
    to {
        transform: scale(0.5);
    }
`;
